import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { PlessSharedModule } from '../../../shared/pless-shared.module';
import { AppCommonsModule } from '../../../commons/app-commons.module';
import { WjGridModule } from '@grapecity/wijmo.angular2.grid';

import { KYMW4403Component } from './kymw4403.component';
import { GetPublishGoodsGroupSelectItemsService } from './api-services/get-publish-goods-group-select-items.service';

/**
 * 掲載商品グループ選択画面 モジュール設定クラス
 *
 * @export KYMW4403Module
 * @class KYMW4403Module
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    AppCommonsModule,
    WjGridModule,
  ],
  declarations: [KYMW4403Component],
  providers: [GetPublishGoodsGroupSelectItemsService],
})
export class KYMW4403Module {}
